import React, { useEffect, useState } from 'react';
import { graphql, Link, useStaticQuery } from 'gatsby';
import TecalisLogo from '../../../new/resources/tecalis.svg';
import LinkButton from '../../v2023/UI/LinkButton/link-button';
import { LanguageDropdown } from '../../v2024/language';
import { ProductsSection } from './products-section';
import { SolutionsSection } from './solutions-section';
import { ResourcesSection } from './resources-section';
import { ProductsSectionMobile } from './products-section-mobile';
import { SolutionsSectionMobile } from './solutions-section-mobile';
import { ResourcesSectionMobile } from './resources-section-mobile';

export const Menu = ({ lang, translates, location }) => {
	const { menuData } = useStaticQuery(graphql`
		query {
			menuData: allStrapi2025Menu {
				edges {
					node {
						locale
						nav_bar_buttons {
							text
							url
							blank
						}
						products_title
						solutions_title
						resources_title
						partners_button {
							text
							url
							blank
						}
						sign_in_button {
							text
							url
							blank
						}
						demo_button {
							text
							url
							blank
						}
						products_section {
							section_title
							section_items {
								title
								url
								color
								image {
									localFile {
										childImageSharp {
											gatsbyImageData(width: 32, placeholder: BLURRED, formats: [WEBP])
										}
									}
								}
								description
							}
						}
						compare_section {
							section_title
							section_items {
								title
								url
							}
							see_all {
								text
								url
								blank
							}
						}
						solutions_section {
							section_title
							section_items {
								title
								url
								image {
									localFile {
										childImageSharp {
											gatsbyImageData(width: 32, placeholder: BLURRED, formats: [WEBP])
										}
									}
								}
								description
							}
							see_all {
								text
								url
								blank
							}
						}
						customer_stories_section {
							title
							customer_card {
								image {
									localFile {
										childImageSharp {
											gatsbyImageData(height: 32, placeholder: BLURRED, formats: [WEBP])
										}
									}
								}
								description
								url
							}
							see_all {
								text
								url
								blank
							}
						}
						resources_section {
							section_title
							section_items {
								title
								url
								image {
									localFile {
										childImageSharp {
											gatsbyImageData
										}
									}
								}
								description
							}
						}
						menu_newsletter_section_2025 {
							title
							description
						}
						newsletter_form {
							region
							portal_id
							form_id
						}
						thank_you_content_suscription {
							url
						}
					}
				}
			}
		}
	`);

	useEffect(() => {
		// Manage to open the submenu
		const openSubmenu = (thisItem) => {
			thisItem.classList.add('show');
			activeSubmenu = thisItem;
		};

		// Manage to close the submenu
		const closeSubmenu = (thisItem) => {
			thisItem.classList.remove('show');
			activeSubmenu = null;
		};

		// Manage to close all the submenus
		const closeAllSubmenu = () => allMenuItems.forEach((submenu) => closeSubmenu(submenu));

		const handleMouseEnter = (e) => {
			const submenu = e.target;
			// Removing the timer, so we cancel every previous action pending to don't open or close other submenus
			clearTimeout(timer);

			// If there is not an active submenu, we instantly open the hovered submenu
			if (!activeSubmenu) {
				openSubmenu(submenu);
			} else {
				timer = setTimeout(() => {
					// If past the timeout we close the other menu that's open
					if (activeSubmenu) {
						closeSubmenu(activeSubmenu);
					}
					// And open the current menu
					openSubmenu(submenu);
				}, delay);
			}
		};

		const handleMouseLeave = (e) => {
			// Removing the timer, so we cancel every previous action pending to don't open or close other submenus
			clearTimeout(timer);
			timer = setTimeout(() => {
				// Closing the exited submenu
				closeSubmenu(e.target);
			}, delay);
		};

		// The timer will hold the timeout id, so we can cancel the actions
		// The activeSubmenu is to know what submenu should be open
		let timer,
			activeSubmenu = null;
		// The delay that the menu will hold to open and close the item
		const delay = 200;
		const allMenuItems = document.querySelectorAll('#header .menu-options__options__option');
		// For each menu item
		for (let i = 0; i < allMenuItems.length; i++) {
			const thisItem = allMenuItems[i];
			// We create a mouse enter event, it will remove the class from the others option and add the active class
			thisItem.addEventListener('mouseenter', (e) => handleMouseEnter(e));

			thisItem.addEventListener('mouseleave', (e) => handleMouseLeave(e));
		}

		// When leaving the header, closing all the submenus
		const header = document.getElementById('header');
		header.addEventListener('mouseleave', () => closeAllSubmenu());

		// Removing all the event listener on the page dismount
		return () => {
			for (let i = 0; i < allMenuItems.length; i++) {
				const thisItem = allMenuItems[i];
				// Removing the event listener to avoid cache
				thisItem.removeEventListener('mouseenter', (e) => handleMouseEnter(e));
				thisItem.removeEventListener('mouseleave', (e) => handleMouseLeave(e));
			}
			header.removeEventListener('mouseleave', () => closeAllSubmenu());
		};
	});

	const [openMenu, setOpenMenu] = useState(false);
	const [openMenuItem, setOpenMenuItem] = useState(-1);
	const [lowerMenu, setLowerMenu] = useState(true);
	const [userScroll, setUserScroll] = useState(0);
	const onClickButtonMenu = (open = true) => {
		if (typeof document !== 'undefined') {
			document.body.style.overflowY = open ? 'hidden' : 'auto';
		}

		if (typeof window !== 'undefined') {
			if (window.scrollY > 40) {
				setLowerMenu(false);
			} else {
				setUserScroll(105 - window.scrollY);
				setLowerMenu(true);
			}
		}

		setOpenMenu(open);
	};
	const selectOpenMenuItem = (index) => {
		if (openMenuItem === index) {
			setOpenMenuItem(-1);
		} else {
			setOpenMenuItem(index);
		}
	};

	const homeUrl = lang === 'en' ? '/' : `/${lang}`;
	const menu = menuData.edges.find((item) => item.node.locale === lang);
	const largeButton = menu.node.nav_bar_buttons[0];
	const nav_bar_buttons_length = menu.node.nav_bar_buttons.length;

	return (
		<header id="header" className="menu">
			<div className="menu__nav-banner">
				<div className="container">
					<div className="menu__nav-banner__notice hidden-md">
						<i className="icon-star i-sm"></i>
						<span>
							<Link to={largeButton.url}>{largeButton.text}</Link>
						</span>
						<i className="icon-arrow-right i-sm"></i>
					</div>
					<div className="menu__nav-banner__actions">
						<LanguageDropdown lang={lang} translates={translates} shortLabel />
						{menu.node.nav_bar_buttons.slice(1).map((btn, index, array) => (
							<LinkButton
								key={btn.id}
								button={btn}
								className={index === array.length - 1 ? "hidden-md" : ""}
							/>
						))}
					</div>
				</div>
			</div>

			<div className="menu__header">
				<div className="container">
					<div className="menu__header__logo">
						<Link to={`${homeUrl}`}>
							<img src={TecalisLogo} alt="Tecalis" title="Tecalis" />
						</Link>
					</div>
					<div className="menu__header__menu-options">
						<ul className="menu-options__options hidden-md">
							<ProductsSection
								title={menu.node.products_title}
								items={menu.node.products_section}
								comparative={menu.node.compare_section}
							/>
							<SolutionsSection
								title={menu.node.solutions_title}
								items={menu.node.solutions_section}
								stories={menu.node.customer_stories_section}
							/>
							<ResourcesSection
								title={menu.node.resources_title}
								items={menu.node.resources_section}
								newsletter={menu.node.menu_newsletter_section_2025}
								newsletterForm={menu.node.newsletter_form}
								lang={lang}
								thankYou={menu.node.thank_you_content_suscription}
							/>
							<li className="menu-options__options__option">
								<LinkButton button={menu.node.partners_button} />
							</li>
						</ul>
					</div>
					<div className="menu__header__actions hidden-md">
						<LinkButton button={menu.node.sign_in_button} className="button button--secondary button--lg" />
						<LinkButton button={menu.node.demo_button} className="button button--primary button--lg" />
					</div>
					{/* ---MENU PARA MOVILES--- */}
					<div className="menu__header__actions-mobile show-md">
						<button className="button-icon" onClick={() => onClickButtonMenu(!openMenu)}>
							<i className={openMenu ? 'icon-close' : 'icon-menu'} />
						</button>
					</div>
					<div className="show-md">
						<div
							className={`menu__header__mobile ${openMenu ? 'menu__header__mobile--open' : ''}`}
							style={lowerMenu ? {top: `${userScroll}px`} : {top: '65px'}}
						>
							<div className="mobile__menu">
								<ProductsSectionMobile
									menuItem="0"
									title={menu.node.products_title}
									items={menu.node.products_section}
									comparative={menu.node.compare_section}
									openMenuItem={openMenuItem}
									selectOpenMenuItem={selectOpenMenuItem}
									onLinkClick={() => onClickButtonMenu(false)}
								/>
								<SolutionsSectionMobile
									menuItem="1"
									title={menu.node.solutions_title}
									items={menu.node.solutions_section}
									stories={menu.node.customer_stories_section}
									openMenuItem={openMenuItem}
									selectOpenMenuItem={selectOpenMenuItem}
									onLinkClick={() => onClickButtonMenu(false)}
								/>
								<ResourcesSectionMobile
									menuItem="2"
									title={menu.node.resources_title}
									items={menu.node.resources_section}
									newsletter={menu.node.menu_newsletter_section_2025}
									newsletterForm={menu.node.newsletter_form}
									openMenuItem={openMenuItem}
									selectOpenMenuItem={selectOpenMenuItem}
									lang={lang}
									onLinkClick={() => onClickButtonMenu(false)}
								/>
								<div className="item" onClick={() => onClickButtonMenu(false)}>
									<div className="item__header">
										<h6>
											<LinkButton button={menu.node.partners_button} />
										</h6>
									</div>
								</div>
								<div className="mobile__menu__actions">
									<LanguageDropdown lang={lang} translates={translates} shortLabel />
									<div className="actions__buttons">
										<LinkButton
											button={menu.node.nav_bar_buttons[nav_bar_buttons_length - 1]}
											className="button button--secondary button--xl"
										/>
										<LinkButton
											button={menu.node.sign_in_button}
											className="button button--secondary button--xl"
										/>
										<LinkButton
											button={menu.node.demo_button}
											className="button button--primary button--xl"
										/>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</header>
	);
};
